import "./index.css";
import React, { useRef, useEffect, useState } from 'react';

let jXMin = 60;
let jXMax = 400;
let jYMin = 560;
let jYMax = 20;

export default function CanvasRenderer({ equations, inputs, window, sliders }) {
    const canvas = useRef(null);

    let getX = (y, slope, yIntercept) => (y - yIntercept) / slope;
    let getY = (x, slope, yIntercept) => (slope * x) + yIntercept;

    function getJavaX(num) {
        let temp = ((((jXMax - jXMin) / (window.maxX - window.minX)) * (num - window.minX)) + jXMin);
        return (Math.round(temp));
    }

    function getJavaY(num) {
        let temp = ((((jYMax - jYMin) / (window.maxY - window.minY)) * (num - window.minY)) + jYMin);
        return (Math.round(Math.abs(temp)));
    }

    const drawGraph = () => {
        /**@type {CanvasRenderingContext2D} */
        let ctx = canvas.current.getContext('2d');

        ctx.clearRect(0, 0, canvas.current.width, canvas.current.height);

        ctx.fillStyle = '#FFFFFF';
        ctx.strokeStyle = '#222222';
        ctx.lineWidth = 1;
        ctx.fillRect(0, 0, canvas.current.width, canvas.current.height);
        ctx.strokeRect(60, 20, canvas.current.width - 80, canvas.current.height - 60);
        ctx.font = '14px Arial';

        if (equations) {
            drawLine(equations.y1, ctx, 'red');
            drawLine(equations.y2, ctx, 'magenta');
            drawLine(equations.y3, ctx, 'blue');
        }

        ctx.strokeStyle = '#222222';
        ctx.lineWidth = 1;
        ctx.fillRect(0, 0, 60, canvas.current.height);
        ctx.fillRect(canvas.current.width - 20, 0, 200, canvas.current.height);


        if (window.minX * window.maxX < 0) {
            let x0 = getJavaX(0);
            ctx.beginPath();
            ctx.moveTo(x0, 20);
            ctx.lineTo(x0, canvas.current.height - 20);
            ctx.stroke();

        }
        if (window.minY * window.maxY < 0) {
            let y0 = getJavaY(0);
            ctx.beginPath();
            ctx.moveTo(60, y0);
            ctx.lineTo(canvas.current.width - 20, y0);
            ctx.stroke();
            ctx.fillText('0', canvas.current.width - 15, y0);
        }

        ctx.fillStyle = '#000000';
        ctx.fillText(window.maxY, 20, 20);
        ctx.fillText(window.minY, 20, canvas.current.height - 40);
        ctx.fillText(window.minX, 60, canvas.current.height - 20);
        ctx.fillText(window.maxX, canvas.current.width - 60, canvas.current.height - 20);

        if (sliders.active == 'x') {
            let x0 = getJavaX(sliders.x);
            ctx.beginPath();
            ctx.moveTo(x0, 20);
            ctx.lineTo(x0, canvas.current.height - 20);
            ctx.setLineDash([5, 5]);
            ctx.stroke();
            ctx.setLineDash([]);
        } else {
            console.log(sliders.y);
            let y0 = getJavaY(sliders.y);
            ctx.beginPath();
            ctx.moveTo(60, y0);
            ctx.lineTo(canvas.current.width - 20, y0);
            ctx.setLineDash([5, 5]);
            ctx.stroke();
            ctx.setLineDash([]);
        }
    }

    const drawLine = (group, ctx, color) => {
        ctx.strokeStyle = color;
        ctx.lineWidth = 2;

        let x0 = getJavaX(getX(window.minY, group.slope, group.yIntercept));
        let y0 = getJavaY(window.minY);
        let x1 = getJavaX(getX(window.maxY, group.slope, group.yIntercept));
        let y1 = getJavaY(window.maxY);

        ctx.beginPath();
        ctx.moveTo(x0, y0);
        ctx.lineTo(x1, y1);
        ctx.stroke();
    }

    useEffect(() => {
        console.log("USE EFFECT")
        console.log(inputs);
        drawGraph();
    }, [inputs, equations, window, sliders])

    return (
            <canvas ref={canvas} id="canvas" width="450" height="600" style={{ width: '450px', height: '600px' }} className='p10 m5 b2'></canvas>
    );
}

